<template>
  <Section :content="ownYourData" />
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import Section from '@/components/section.vue';
export default {
  name: 'SectionOwnYourData',
  components: {
    Section,
  },
  data() {
    return {
      ownYourData: { 
        eyebrow: 'TrinPod\u2122',
        eyebrowIcon: 'trinity_secure.png',
        headline: 'Own Your Data',
        paragraphs: [
          'Your data is valuable. Big tech is offering solutions where they access and enrich themselves from your data.',
          'With TrinPod\u2122 you will 100% own your data, and 100% control access to your data. Period.'
        ],
        id: 'own-your-data',
        image: 'solid-pod-access-corp.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-neon-blue-grad',
        /*html:
          '<div>' + 
          ' <h5 class="mb-4">Your data is valuable. Big tech is offering solutions where they access and enrich themself from your data.' +
          ' <h5 class="mb-4">With TrinPod\u2122 you will 100% own your data, and 100% control access to your data. Period.</h5>' +
          '</div>',*/
        learnMoreLink: '/trinpod'
      }
    }
  }
};
</script>
